module.exports = __webpack_public_path__ + "img/bg_dashboard_workingtime.58763f3.png";